export default __webpack_public_path__ + "static/media/logo_bfc.8ffb4e36.png";